import script from "./EvalDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./EvalDashboard.vue?vue&type=script&setup=true&lang=js"

import "./EvalDashboard.vue?vue&type=style&index=0&id=564af343&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-564af343"]])

export default __exports__